export default __webpack_public_path__ + "static/media/shuttersto-027b04e4edc92ef.3a130fbc.jpg";